
let activeHeaderId = 0;
let quantityHeader = document.querySelectorAll('.top-header').length;
const timeDelay = 10000;
let intervalId = null;

class topHeaderHandler {

    constructor() {
        let topHeaderInfo = document.querySelectorAll('.top-header-info');
        let mainHeader = document.querySelector('.main-header');

        if (topHeaderInfo != null) {
            topHeaderInfo.forEach(button => {
                button.addEventListener('mouseenter', (event) => {
                    if (topHeaderInfo[activeHeaderId].getAttribute('data-url') !== '') {
                        button.style.cursor = 'pointer';
                    } else {
                        button.style.cursor = 'default';
                    }
                });

                button.addEventListener("click", (event) => {
                    event.preventDefault();

                    const url = topHeaderInfo[activeHeaderId].getAttribute('data-url');
                    if (url !== '') {
                        window.location.href = url;
                    }
                })
            });
        } else {
            if ( mainHeader != null) {
                mainHeader.style.marginTop = '0px';
            }
        }
    }
}

function delay(time) {
    return new Promise(resolve => setTimeout(resolve, time));
}

export function topHeader() {
    new topHeaderHandler();

    if (quantityHeader > 1) {
        intervalId = setInterval(function(){
            let topHeader = document.querySelectorAll('.top-header');

            activeHeaderId++;
            if (activeHeaderId >= quantityHeader) {
                activeHeaderId = 0;

                topHeader[activeHeaderId].classList.remove("header-first");
            }
            topHeader[activeHeaderId].classList.add("active");

            delay(1000).then(() => {
                if (activeHeaderId <= 0) {
                    topHeader[quantityHeader - 1].classList.remove("active");
                } else {
                    topHeader[activeHeaderId - 1].classList.remove("active");
                }
            });
        }, timeDelay);
    }
}
